import { Navigate } from 'react-router-dom';
import constants from '../constants';
import { useAuth } from '../contexts/authContext';

export default function DashboardPage() {
  const auth = useAuth();

  const route = auth.user.roleId === 3 ? constants.routes.USERS_RESERVATION.path : constants.routes.WORKOUTS_MANAGEMENT.path;

  return <Navigate to={route} replace />;

}